module.exports = __webpack_public_path__ + "img/3_1_1.77be174c.jpg";